import { jsx as _jsx } from "react/jsx-runtime";
import { StoreType } from "@faire/retailer-shared/lib/StoreType";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IOffer } from "@faire/web-api--source/indigofair/data/IOffer";
import React from "react";
import { getStoreType } from "@faire/retailer/serialized-data/getStoreType";
export var getVerticalizedTopBannerText = function(param) {
    var formattedIncentivePercentNumber = param.formattedIncentivePercentNumber, offerName = param.offerName, _param_storeType = param.storeType, storeType = _param_storeType === void 0 ? getStoreType() : _param_storeType, isMaximalistFoi = param.isMaximalistFoi, isFoiForFD = param.isFoiForFD;
    if (isFoiForFD) {
        return getFoiForFaireDirectVerticalizedTopBannerText({
            formattedIncentivePercentNumber: formattedIncentivePercentNumber,
            offerName: offerName,
            storeType: storeType
        });
    }
    if (isMaximalistFoi) {
        return getMaximalistFoiVerticalizedTopBannerText({
            formattedIncentivePercentNumber: formattedIncentivePercentNumber,
            offerName: offerName,
            storeType: storeType
        });
    }
    switch(storeType){
        case StoreType.GIFT:
        case StoreType.HOME_DECOR:
        case StoreType.FURNITURE:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "J+YNjw",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop seasonal decor, home accents, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.BOOK:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "ABboeU",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop books, journals, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.SPA_OR_SALON:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "0jIYXt",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop beauty, wellness, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.PET:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "tEYwCK",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop pet treats, toys, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.FLORIST_OR_GARDEN:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "sEg0TS",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop flowers, vases, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.KIDS_OR_TOY:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "vc326b",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop toys, games, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.FITNESS_OR_YOGA:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "R+7qoY",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop yoga, fitness, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.CLOTHING:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "pkwKlI",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop apparel, accessories, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.CAFE_OR_RESTAURANT:
        case StoreType.GROCERY_OR_LIQUOR:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "hnKcgb",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop food, drinks, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.OTHER:
        case StoreType.GENERAL:
        default:
            return getGenericTopBannerText({
                formattedIncentivePercentNumber: formattedIncentivePercentNumber,
                offerName: offerName
            });
    }
};
var getMaximalistFoiVerticalizedTopBannerText = function(param) {
    var formattedIncentivePercentNumber = param.formattedIncentivePercentNumber, offerName = param.offerName, _param_storeType = param.storeType, storeType = _param_storeType === void 0 ? getStoreType() : _param_storeType;
    switch(storeType){
        case StoreType.GIFT:
        case StoreType.HOME_DECOR:
        case StoreType.FURNITURE:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "UeBYf/",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop seasonal decor, home accents, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.BOOK:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "yMZBlP",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop books, journals, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.SPA_OR_SALON:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "QNHtQc",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop beauty, wellness, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.PET:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "rAnJi4",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop pet treats, toys, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.FLORIST_OR_GARDEN:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "2EIvhW",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop flowers, vases, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.KIDS_OR_TOY:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "xupyz+",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop toys, games, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.FITNESS_OR_YOGA:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "lwYALu",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop yoga, fitness, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.CLOTHING:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "KLKpYg",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop apparel, accessories, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.CAFE_OR_RESTAURANT:
        case StoreType.GROCERY_OR_LIQUOR:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "SrtsUV",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off and free shipping!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop food, drinks, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.OTHER:
        case StoreType.GENERAL:
        default:
            return getGenericTopBannerText({
                formattedIncentivePercentNumber: formattedIncentivePercentNumber,
                offerName: offerName,
                isMaximalistFoi: true
            });
    }
};
var getFoiForFaireDirectVerticalizedTopBannerText = function(param) {
    var formattedIncentivePercentNumber = param.formattedIncentivePercentNumber, offerName = param.offerName, _param_storeType = param.storeType, storeType = _param_storeType === void 0 ? getStoreType() : _param_storeType;
    switch(storeType){
        case StoreType.GIFT:
        case StoreType.HOME_DECOR:
        case StoreType.FURNITURE:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "K5L+eS",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop seasonal decor, home accents, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.BOOK:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "lbdZUG",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop books, journals, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.SPA_OR_SALON:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "GZQ3Ik",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop beauty, wellness, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.PET:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "cm0Yol",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop pet treats, toys, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.FLORIST_OR_GARDEN:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "4rbf8L",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop flowers, vases, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.KIDS_OR_TOY:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "s+6LS/",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop toys, games, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.FITNESS_OR_YOGA:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "sVsSv4",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop yoga, fitness, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.CLOTHING:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "9ih3mQ",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop apparel, accessories, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.CAFE_OR_RESTAURANT:
        case StoreType.GROCERY_OR_LIQUOR:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "oklUEK",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off with any brand!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop food, drinks, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
        case StoreType.OTHER:
        case StoreType.GENERAL:
        default:
            return getGenericTopBannerText({
                formattedIncentivePercentNumber: formattedIncentivePercentNumber,
                offerName: offerName,
                isFoiForFD: true
            });
    }
};
var getGenericTopBannerText = function(param) {
    var formattedIncentivePercentNumber = param.formattedIncentivePercentNumber, isFoiForFD = param.isFoiForFD, isMaximalistFoi = param.isMaximalistFoi, offerName = param.offerName;
    switch(offerName){
        case IOffer.RetailerOfferName.FAIRE_DIRECT_MARKETPLACE_DISCOUNT:
        case IOffer.RetailerOfferName.EVERGREEN_MARKETPLACE_DISCOUNT:
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "/r0SRp",
                defaultMessage: [
                    {
                        type: 8,
                        value: "BoldFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "promoMoney"
                            },
                            {
                                type: 0,
                                value: " off"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " your next order with any new brand!"
                    }
                ],
                values: {
                    BoldFormatting: MediumFormatting,
                    promoMoney: formattedIncentivePercentNumber
                }
            });
        default:
            if (isFoiForFD) {
                return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "zt5ms/",
                    defaultMessage: [
                        {
                            type: 8,
                            value: "MediumFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Enjoy "
                                },
                                {
                                    type: 1,
                                    value: "formattedIncentivePercentNumber"
                                },
                                {
                                    type: 0,
                                    value: " off with any brand!"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " Shop bestsellers, eco-friendly products, and more."
                        }
                    ],
                    values: {
                        MediumFormatting: MediumFormatting,
                        formattedIncentivePercentNumber: formattedIncentivePercentNumber
                    }
                });
            }
            if (isMaximalistFoi) {
                return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "XQOVyJ",
                    defaultMessage: [
                        {
                            type: 8,
                            value: "MediumFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Enjoy "
                                },
                                {
                                    type: 1,
                                    value: "formattedIncentivePercentNumber"
                                },
                                {
                                    type: 0,
                                    value: " off and free shipping!"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: " Shop bestsellers, eco-friendly products, and more."
                        }
                    ],
                    values: {
                        MediumFormatting: MediumFormatting,
                        formattedIncentivePercentNumber: formattedIncentivePercentNumber
                    }
                });
            }
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "H66dl7",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Enjoy "
                            },
                            {
                                type: 1,
                                value: "formattedIncentivePercentNumber"
                            },
                            {
                                type: 0,
                                value: " off!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Shop bestsellers, eco-friendly products, and more."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    formattedIncentivePercentNumber: formattedIncentivePercentNumber
                }
            });
    }
};
